import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";

// The Genesis · Day One opens 15:00 Stockholm time on 19 Aug 2026
// Stockholm is UTC+2 in August (CEST) → 13:00 UTC
const TARGET = new Date(Date.UTC(2026, 7, 19, 13, 0, 0)); // month 7 = Aug
const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function diff(now) {
  const ms = TARGET.getTime() - now.getTime();
  if (ms <= 0) return null; // event in progress / past
  return {
    days: Math.floor(ms / DAY),
    hours: Math.floor((ms % DAY) / HOUR),
    minutes: Math.floor((ms % HOUR) / MINUTE),
    seconds: Math.floor((ms % MINUTE) / SECOND),
  };
}

function Tile({ value, label }) {
  return (
    <div className="text-center">
      <div className="font-serif text-3xl md:text-5xl text-cream tabular-nums leading-none">
        {String(value).padStart(2, "0")}
      </div>
      <div className="text-[10px] tracking-[0.2em] uppercase text-cream/70 mt-1">
        {label}
      </div>
    </div>
  );
}

export default function Countdown() {
  const [t, setT] = useState(() => diff(new Date()));

  useEffect(() => {
    const id = setInterval(() => setT(diff(new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  if (!t) return null; // hide once the festival starts

  return (
    <section
      className="bg-navy border-t border-cream/10"
      data-testid="countdown-banner"
    >
      <div className="container-x py-6 md:py-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-coral/15 text-coral flex items-center justify-center">
            <Calendar size={18} />
          </div>
          <div>
            <p className="text-[10px] font-bold tracking-[0.22em] uppercase text-coral">
              The Genesis opens in
            </p>
            <p className="text-cream/80 text-sm">
              Wed 19 August 2026 · 15:00 · Grinda
            </p>
          </div>
        </div>
        <div
          className="flex gap-5 md:gap-8 md:ml-auto"
          aria-label="Countdown to The Genesis"
        >
          <Tile value={t.days} label="Days" />
          <Tile value={t.hours} label="Hrs" />
          <Tile value={t.minutes} label="Min" />
          <Tile value={t.seconds} label="Sec" />
        </div>
      </div>
    </section>
  );
}
